import axios from 'axios';
import {prescript} from '../providers/prescript.ts';

const api = axios.create(
    {
        baseURL: import.meta.env.SZB_API_URL as string,
        withCredentials: true,
    }
);


api.interceptors.request.use((config) => {
    config.params = config.params || {};

    // @ts-ignore
    config.headers = {
        ...config.headers,
        tenant_id: prescript.tenantId,
        device: 'desktop',
        'x-szb-tenant-id': prescript.tenantId,
        'x-szb-device': 'desktop',
    };

    return config;
});

export {
    api
};